<div id="app-consumer-sign-in" fxLayout="column" class="app-primary-bg"
    [ngStyle]="{'--form-input-text-color': settingsData.form_font_secondary_color || null, 'background-color':this.settingsData.form_bg_color?this.settingsData.form_bg_color:'', 'border-radius': '10px','padding':this.settingsData.form_bg_color?'20px':'','font-family': settingsData.font_family ? settingsData.font_family : ''}">
    <mat-toolbar matDialogTitle class="mat-accent m-0">
        <mat-toolbar-row
            [ngStyle]="{'background-color':this.settingsData.form_bg_color?this.settingsData.form_bg_color: 'transparent' }">
            <button *ngIf="!forceSignIn" tabindex="-1" mat-icon-button (click)="closeModal()" aria-label="Close dialog" class="close-button">
                <mat-icon class="fw-bold"
                    [ngStyle]="{ 'color': settingsData.form_font_secondary_color ? settingsData.form_font_secondary_color : ''}">
                    close</mat-icon>
            </button>
            <div fxLayoutAlign="center center" class="auth-dialogs w-100">
                <span
                    [ngStyle]="{ 'color': settingsData.form_font_secondary_color ? settingsData.form_font_secondary_color : '' , 'font-size': settingsData.form_fs_main_title ? settingsData.form_fs_main_title: '','font-family': settingsData.font_family ? settingsData.font_family : ''  }">
                    SIGN IN</span>
            </div>
        </mat-toolbar-row>
    </mat-toolbar>
    <!-- <mat-divider></mat-divider> -->
    <!-- <h5 class="text-center"
        [ngStyle]="{ 'color': settingsData.form_font_secondary_color ? settingsData.form_font_secondary_color : '' ,'font-family': settingsData.font_family ? settingsData.font_family : '' }"
        *ngIf="deviceType != 'ios'">Connect With</h5> -->
    <!-- <div fxFlex="100%" fxFlex.xs="100%" fxLayoutAlign="center center" class="mtb-5 social-icons pointer"
        *ngIf="deviceType != 'ios'">
        <i class="fa fa-facebook" (click)="OL_signInSocial('faceBook')"></i>
        <i class="fa fa-google ml-10" (click)="OL_signInSocial('google')"></i>
        <i class="fa fa-linkedin ml-10" (click)="OL_signInSocial('linkedin')"></i> -->
    <!-- <img src="assets/google.png" class="google-icon mr-10" (click)="OL_signInSocial('google')">
        <img src="assets/facebook.png" class="facebook-icon mr-10" (click)="OL_signInSocial('faceBook')">
        <img src="assets/linkedin.png" class="facebook-icon" (click)="OL_signInSocial('linkedin')"> -->
    <!-- </div> -->
    <!-- <p class="pt-15 mb-0 text-center"
        [ngStyle]="{ 'color': settingsData.form_font_secondary_color ? settingsData.form_font_secondary_color : '' ,'font-family': settingsData.font_family ? settingsData.font_family : '' }"
        *ngIf="deviceType != 'ios'">OR</p> -->
    <div mat-dialog-content>
        <form [formGroup]="signInForm">
            <div fxLayout="column" fxLayoutAlign="center center">
                <div fxFlex="100%" class="mt-10 w-100">
                    <mat-form-field class="w-100" [style.--form-border-color]="settingsData?.form_font_secondary_color"
                        [style.--before-border-color]="settingsData?.form_font_secondary_color">
                        <mat-label><span
                                [ngStyle]="{ 'color': settingsData.form_font_secondary_color ? settingsData.form_font_secondary_color : '' ,'font-family': settingsData.font_family ? settingsData.font_family : '' }">Email</span>
                        </mat-label>
                        <input matInput name="email" formControlName="email"
                            [style.color]="settingsData?.form_font_secondary_color + ' !important'" allowValues
                            isInputType="removeSpace" required>
                        <mat-error *ngIf="signInForm?.get('email')?.hasError('required')">
                            Please enter email
                        </mat-error>
                        <mat-error
                            *ngIf="signInForm?.get('email')?.hasError('email') || signInForm?.get('email')?.hasError('pattern')">
                            Please enter valid email
                        </mat-error>
                    </mat-form-field>
                </div>

                <div fxFlex="100%" class="pt-10 w-100">
                    <mat-form-field class="w-100" [style.--form-border-color]="settingsData?.form_font_secondary_color"
                        [style.--before-border-color]="settingsData?.form_font_secondary_color">
                        <mat-label> <span
                                [ngStyle]="{ 'color': settingsData.form_font_secondary_color ? settingsData.form_font_secondary_color : '' ,'font-family': settingsData.font_family ? settingsData.font_family : '' }">Password</span>
                        </mat-label>
                        <input type="password" matInput name="password" formControlName="password"
                            [style.color]="settingsData?.form_font_secondary_color + ' !important'" required>
                        <mat-error *ngIf="signInForm?.get('password')?.hasError('required')">
                            Please enter password
                        </mat-error>
                    </mat-form-field>
                </div>

                <!-- <div class="mt-30 mb-25">
                    <button mat-flat-button class="square-btn" (click)="consumerSignIn();">
                        Sign In
                    </button>
                </div> -->
                <div class="mb-25 mt-15">
                    <button mat-flat-button class="flat-primary-button primary-bg-button" [ngClass]="{
                            'dynamic-bg': settingsData.form_bg_secondary_color,
                            'dynamic-text': settingsData.form_font_primary_color,
                            'dynamic-font-family': settingsData.font_family
                        }" [ngStyle]="{
                            '--dynamic-bg-color': settingsData.form_bg_secondary_color,
                            '--dynamic-text-color': settingsData.form_font_primary_color,
                            '--dynamic-font-family': settingsData.font_family
                        }" (click)="signInFromOneLogin();">
                        Sign In Now
                    </button>
                </div>
                <!-- <div class="login-buttons-container">
                    <button class="login-btn" (click)="loginWithGoogle()">
                        <img src="../../../../../../assets/social_logins/google.svg" height="30">

                    </button>
                    <button class="login-btn" (click)="loginWithApple()">
                        <img src="../../../../../../assets/social_logins/apple.svg" height="30">

                    </button>
                </div> -->

                <!-- <div class="mtb-5 pointer">
                    <span class="ff c-l-g" (click)="OpenSign()">Sign as <span class="c-p">Creator</span></span>
                </div> -->
                <div class="mtb-5 pointer" *ngIf="!forceSignIn">
                    <span class=" c-l-g" (click)="openForgotPassword()"
                        [ngStyle]="{ 'color': settingsData.form_font_secondary_color ? settingsData.form_font_secondary_color : '' ,'font-family': settingsData.font_family ? settingsData.font_family : '' }">Forgot
                        Password?</span>
                </div>
                <!-- <div fxFlex="100%" fxFlex.xs="100%" fxLayoutAlign="center center" class="mtb-5" style="color: #847B7B;">
                    - OR -
                </div>
                <div fxFlex="100%" fxFlex.xs="100%" fxLayoutAlign="center center" class="mtb-5">
                    SIGN IN WITH
                </div> -->
                <!-- <div fxFlex="100%" fxFlex.xs="100%" fxLayoutAlign="center center" class="mtb-5 social-icons pointer">
                    <i class="fa fa-google" (click)="OL_signInSocial('google')"></i>
                    <i class="fa fa-facebook ml-10" (click)="OL_signInSocial('faceBook')"></i>
                    <i class="fa fa-linkedin ml-10" (click)="OL_signInSocial('linkedin')"></i> -->
                <!-- <img src="assets/google.png" class="google-icon mr-10" (click)="OL_signInSocial('google')">
                    <img src="assets/facebook.png" class="facebook-icon mr-10" (click)="OL_signInSocial('faceBook')">
                    <img src="assets/linkedin.png" class="facebook-icon" (click)="OL_signInSocial('linkedin')"> -->
                <!-- </div> -->
                <div class="mt-5 mb-20 pointer">
                    <span (click)="consumerOpenSignUp()"
                        [ngStyle]="{ 'color': settingsData.form_font_secondary_color ? settingsData.form_font_secondary_color : '' ,'font-family': settingsData.font_family ? settingsData.font_family : '' }">
                        <span class="go-to-account"
                            [ngStyle]="{ 'color': settingsData.form_font_secondary_color ? settingsData.form_font_secondary_color : '' ,'font-family': settingsData.font_family ? settingsData.font_family : '' }">
                            Don't have an account?&nbsp;
                        </span>
                        <span
                            [ngStyle]="{ 'color': settingsData.form_font_secondary_color ? settingsData.form_font_secondary_color : '' ,'font-family': settingsData.font_family ? settingsData.font_family : '' }">
                            Sign Up </span>
                    </span>
                </div>
            </div>
        </form>
    </div>
</div>